module.exports = __webpack_public_path__ + "static/img/go_banner_download_tablet.748df89.png";